import {
  ITEMS_FETCH_SUCCESS,
  GET_ITEM_SUCCESS,
  ITEM_LOADING,
  SET_ITEM_DRAFT,
  SET_ITEM_ADDRESS_DRAFT,
  SET_ITEM_OPTIONS_DRAFT,
  CATEGORIES_FETCH_SUCCESS,
  SET_ITEM_IMAGES_DRAFT
} from '../constant/actionType';

const initialState = {
  categories: [],
  isLoaded: false,
  itemAddressDraft: {},
  itemDraft: {},
  itemImagesDraft: [],
  itemOptionsDraft: {},
  items: [],
  selectedItem: {}
};

const itemReducer = (state = initialState, action) => {
  switch (action.type) {
    case ITEMS_FETCH_SUCCESS:
      return {
        ...state,
        items: action.data
      };
    case CATEGORIES_FETCH_SUCCESS:
      return {
        ...state,
        categories: action.data
      };
    case GET_ITEM_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        itemAddressDraft: action.data?.address,
        itemDraft: action.data,
        itemImagesDraft: action.data?.images,
        itemOptionsDraft: action.data?.options,
        selectedItem: action.data
      };
    case ITEM_LOADING:
      return {
        ...state,
        isLoaded: false
      };
    case SET_ITEM_DRAFT:
      return {
        ...state,
        itemDraft: action.data
      };
    case SET_ITEM_ADDRESS_DRAFT:
      return {
        ...state,
        itemAddressDraft: action.data
      };
    case SET_ITEM_OPTIONS_DRAFT:
      return {
        ...state,
        itemOptionsDraft: action.data
      };
    case SET_ITEM_IMAGES_DRAFT:
      return {
        ...state,
        itemImagesDraft: action.data
      };
    default:
      return state;
  }
};

export default itemReducer;
